module.exports = __webpack_public_path__ + "img/logo.df769a43.png";